let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ecM21")).then(() => parcelRequire('67zLr'));